// extracted by mini-css-extract-plugin
export default {"section":"Experience_section__Rphnx"};